import React from 'react'
import { ScaleLinear } from 'd3-scale'
export const YTicks = ({
  data,
  x,
  y,
  maxwidth,
}: {
  data: yTicksDataType
  x: ScaleLinear<number, number>
  y: ScaleLinear<number, number>
  maxwidth?: number
}) => {
  if (!data) return null
  const textOffsetY = 13
  return (
    <>
      {data.lines &&
        data.lines.map((t, i) => {
          return (
            <line
              key={i}
              y1={y(t)}
              y2={y(t)}
              x1={x.range()[0]}
              x2={maxwidth || x.range()[1]}
              className={'tickline ' + (t === 0 ? 'base' : '')}
            />
          )
        })}
      {data.text &&
        data.text.map((t, i) => {
          return (
            <text
              key={i}
              x={x.range()[0] + 3}
              y={y(t) + textOffsetY}
              className='ticktext'
            >
              {t}{data.suffix && data.suffix}
            </text>
          )
        })}
    </>
  )
}
